// extracted by mini-css-extract-plugin
export default {"menu":"styles_menu__BWW+T","itemMenu":"styles_itemMenu__tXP-0","horizontalLine":"styles_horizontalLine__7V15t","background":"styles_background__WdnUx"};